// SetMapRef.tsx
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { Map } from 'leaflet';

interface SetMapRefProps {
  mapRef: React.MutableRefObject<Map | null>;
}

const SetMapRef: React.FC<SetMapRefProps> = ({ mapRef }) => {
  const map = useMap();
  useEffect(() => {
    mapRef.current = map;
  }, [map, mapRef]);
  return null;
};

export default SetMapRef;
